import React, { Fragment, useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import API from '../../services/API';
import { Nav, NavItem, NavLink, TabContent, TabPane, Table, Modal, ModalHeader, ModalBody, ModalFooter, Button } from 'reactstrap';
import Calendar from 'react-calendar';
import 'react-calendar/dist/Calendar.css';
import Papa from "papaparse";
import L from "leaflet";
import { MapContainer, TileLayer, Marker, Popup, useMap } from "react-leaflet";
import "leaflet/dist/leaflet.css";
import classnames from "classnames";
import moment from 'moment';
import AddTimetableModal from "../dashboard/Timetable/AddTimeTableModal";
import TimetableTab from '../dashboard/Timetable/TimetableTab';

import dayjs from 'dayjs'; // Import dayjs for date handling

const ClassProfile = () => {
    const glowingIcon = L.divIcon({
        className: "", // leave blank so only our HTML applies
        html: `<div class="glow-circle"></div>`,
        iconSize: [70, 70],   // overall container size
        iconAnchor: [0, 0], // anchor in the center
    });
    const FitBounds = ({ points }) => {
        const map = useMap();

        useEffect(() => {
            if (points && points.length > 0) {
                const bounds = L.latLngBounds(points.map(p => [p.latitude, p.longitude]));
                map.fitBounds(bounds, { padding: [50, 50] });
            }
        }, [points, map]);

        return null;
    };

    const classId = window.location.pathname.split('/').pop(); // Extract class ID from URL
    const [students, setStudents] = useState([]); // List of students
    const [className, setClassName] = useState('');
    const [selectedDate, setSelectedDate] = useState(new Date()); // Selected date on the calendar
    const [loading, setLoading] = useState(false);
    const [allClasses, setAllClasses] = useState([]);
    const [selectedStudent, setSelectedStudent] = useState(null);
    const [newClassId, setNewClassId] = useState('');
    const [modalOpen, setModalOpen] = useState(false);
    const [nameModalOpen, setNameModalOpen] = useState(false);
    const [newStudentName, setNewStudentName] = useState('');
    const [summary, setSummary] = useState([]);
    const [recordModalOpen, setRecordModalOpen] = useState(false);
    const [recordStartDate, setRecordStartDate] = useState('');
    const [recordEndDate, setRecordEndDate] = useState('');
    const [recordStatus, setRecordStatus] = useState(1);
    const [recordRemarks, setRecordRemarks] = useState('');
    const [mcReasons, setMCReasons] = useState([]);
    const [selectedMCReason, setSelectedMCReason] = useState(null);
    const [deleteModalOpen, setDeleteModalOpen] = useState(false);
    const [studentToDelete, setStudentToDelete] = useState(null);
    const [deleting, setDeleting] = useState(false);
    const [confirmPresentModalOpen, setConfirmPresentModalOpen] = useState(false);
    const [unrecordedList, setUnrecordedList] = useState([]);
    const [registerModalOpen, setRegisterModalOpen] = useState(false);
    const [registering, setRegistering] = useState(false);
    const [newStudent, setNewStudent] = useState({
        first_name: "",
        moeis_name: "",
        class_id: classId,
    });
    const [csvFile, setCsvFile] = useState(null);
    const [activeTab, setActiveTab] = useState("manual"); // "manual" or "csv"
    const [parsedCsvNames, setParsedCsvNames] = useState([]);
    const [rawInput, setRawInput] = useState("");
    const [rawNames, setRawNames] = useState([]);
    const [rawCheckResults, setRawCheckResults] = useState(null);
    const [csvCheckResults, setCsvCheckResults] = useState(null);
    const [confirmAbsentModalOpen, setConfirmAbsentModalOpen] = useState(false);
    const [selectedBulkMCReason, setSelectedBulkMCReason] = useState(null);
    // states
    const [activeSubTab, setActiveSubTab] = useState("students");
    const [addModalOpen, setAddModalOpen] = useState(false);
    const [timetable, setTimetable] = useState([]);
    const [rotationCycle, setRotationCycle] = useState(1);
    const [currentViewDate, setCurrentViewDate] = useState(new Date());

    const [loadingTimetable, setLoadingTimetable] = useState(false);
    const [teachers, setTeachers] = useState([]);
    const [startBulkDate, setStartBulkDate] = useState("");
    const [endBulkDate, setEndBulkDate] = useState("");
    const [activeMonthDate, setActiveMonthDate] = useState(new Date());


    // tab toggle
    const toggleSubTab = (tab) => {
        if (activeSubTab !== tab) setActiveSubTab(tab);
    };
    const [selectedDay, setSelectedDay] = useState("Monday");

    const filteredTimetable = timetable.filter(
        (item) => item.day_of_week === selectedDay
    );

    const statusMap = {
        "0": { text: "Unrecorded", color: "secondary" },
        "1": { text: "Recording in Progress", color: "warning" },
        "2": { text: "Recorded (Parents Linked)", color: "info" },
        "4": { text: "Recorded", color: "success" },
        "error": { text: "Error / Conflict", color: "danger" },
        "duplicate": { text: "Duplicate Entry", color: "dark" },
        "conflict": { text: "Class Conflict", color: "danger" },
    };


    const openDeleteModal = (student) => {
        setStudentToDelete(student);
        setDeleteModalOpen(true);
    };

    const closeDeleteModal = () => {
        setDeleteModalOpen(false);
        setStudentToDelete(null);
    };

    useEffect(() => {
        getClassName();
        fetchAllClasses();
        getMCReasons();
    }, [classId]);

    const openRecordAttendanceModal = (student) => {
        setSelectedStudent(student);
        setRecordStartDate(dayjs(selectedDate).format('YYYY-MM-DD'));
        setRecordEndDate(dayjs(selectedDate).format('YYYY-MM-DD'));
        setRecordStatus(1);
        setRecordRemarks('');
        setRecordModalOpen(true);
    };


    const openNameModal = (student) => {
        setSelectedStudent(student);
        setNewStudentName(student.first_name);
        setNameModalOpen(true);
    };

    const closeNameModal = () => {
        setSelectedStudent(null);
        setNewStudentName('');
        setNameModalOpen(false);
    };
    const fetchTeachers = () => {
        const headers = {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'token': localStorage.getItem('token'),
        };

        API.get('/portal/getTeachers', { headers })
            .then((response) => {
                if (response.data.response_code === 1000) {

                    const teacherOptions = response.data.data.map((teacher) => ({
                        label: teacher.full_name,
                        value: teacher.teacher_uuid,
                    }));

                    setTeachers(teacherOptions);
                } else {
                    toast.error(`${response.data.message}`, { autoClose: 5000 });
                }
            })
            .catch(() => {
                toast.error("Error fetching teachers", { autoClose: 5000 });
            });
    };

    const updateStudentName = async () => {
        if (!selectedStudent || !newStudentName.trim()) {
            toast.error("Please enter a valid name.", { autoClose: 5000 });
            return;
        }

        const headers = {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'token': localStorage.getItem('token'),
        };

        try {
            const response = await API.post(
                '/portal/modifyStudentName',
                { student_id: selectedStudent.student_uuid, new_name: newStudentName.trim() },
                { headers }
            );

            if (response.data.response_code === 1000) {
                toast.success("Student name updated successfully!", { autoClose: 5000 });
                fetchStudentsAttendanceDetail(selectedDate);
                fetchStudentsAttendanceSummary(selectedDate);
                closeNameModal();
            } else {
                toast.error(response.data.message, { autoClose: 5000 });
            }
        } catch (error) {
            toast.error(`Error updating student name ${error}`, { autoClose: 5000 });
        }
    };
    const getClassName = async () => {
        const headers = {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'token': localStorage.getItem('token'),
        };

        try {
            const response = await API.post(
                `/school/classID`,
                { class_id: classId }, // Include class_id and date in the body
                { headers }
            );
            if (response.data.response_code === 1000) {
                setClassName(response.data.data.class_name || ''); // Update students data
                fetchStudentsAttendanceDetail(new Date());
                fetchStudentsAttendanceSummary(new Date());
            } else {
                toast.error(response.data.message, { autoClose: 5000 });
            }
        } catch (error) {
            toast.error("Error fetching class name", { autoClose: 5000 });
        } finally {

        }
    }
    const fetchTimetable = async () => {
        setLoadingTimetable(true);
        try {
            const token = localStorage.getItem("token");
            const response = await API.get("/timetable/list", {
                headers: { token },
                params: { is_portal: true, class_id: classId },
            });

            if (response.data.response_code === 1000) {
                setTimetable(response.data.data || []);
            } else {
                toast.error(response.data.message || "Failed to fetch timetable");
                setTimetable([]);
            }
        } catch (error) {
            console.error("❌ Timetable fetch error:", error);
            toast.error("Error fetching timetable data");
            setTimetable([]);
        } finally {
            setLoadingTimetable(false);
        }
    };


    const fetchAllClasses = async () => {
        const headers = {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'token': localStorage.getItem('token'),
        };
        try {
            const response = await API.get(`/school/classes`, { headers });
            if (response.data.response_code === 1000) {
                setAllClasses(response.data.data || []);
            } else {
                toast.error("Failed to fetch class list", { autoClose: 5000 });
            }
        } catch (error) {
            toast.error("Error fetching class list", { autoClose: 5000 });
        }
    };
    const fetchStudentsAttendanceSummary = async (date) => {
        setLoading(true);
        const headers = {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'token': localStorage.getItem('token'),
        };
        const formattedDate = dayjs(date).format('YYYY-MM'); // Format as YYYY-MM-DD

        try {
            const response = await API.post(
                `/attendance/attendanceByClassSummary`,
                { class_id: classId, month:formattedDate }, // Include class_id and date in the body
                { headers }
            );

            if (response.data.response_code === 1000) {
                const result = response.data.data || {};

                setSummary({
                    date_summary: result.date_summary || [],
                    holidays: result.holidays || [],
                });
            } else {
                toast.error(response.data.message, { autoClose: 5000 });
            }
        } catch (error) {
            console.error('Error fetching students:', error);
            toast.error("Error fetching students", { autoClose: 5000 });
        } finally {
            setLoading(false);
        }
    };
    // Fetch students based on class and selected date
    const fetchStudentsAttendanceDetail = async (date) => {
        setLoading(true);
        setStudents([]);
        const headers = {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'token': localStorage.getItem('token'),
        };
        const formattedDate = dayjs(date).format('YYYY-MM-DD'); // Format as YYYY-MM-DD

        try {
            const response = await API.post(
                `/attendance/attendanceByClassDetail`,
                { class_id: classId, date: formattedDate }, // Include class_id and date in the body
                { headers }
            );
            if (response.data.response_code === 1000) {
                setStudents(response.data.data || []); // Update students data
            } else {
                toast.error(response.data.message, { autoClose: 5000 });
            }
        } catch (error) {
            console.error('Error fetching students:', error);
            toast.error("Error fetching students", { autoClose: 5000 });
        } finally {
            setLoading(false);
        }
    };
    const confirmDeleteStudent = async () => {
        if (!studentToDelete) return;
        setDeleting(true); // <--- Add this

        const headers = {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'token': localStorage.getItem('token'),
        };
        try {
            const response = await API.post(
                '/portal/delete',
                { student_id: studentToDelete.student_uuid },
                { headers }
            );
            if (response.data.code === 1000 || response.data.response_code === 1000) {
                toast.success(response.data.message || "Student deleted successfully!", { autoClose: 5000 });
                // Refresh data after deletion
                fetchStudentsAttendanceDetail(selectedDate);
                fetchStudentsAttendanceSummary(selectedDate);
            } else {
                toast.error(response.data.message || "Failed to delete student", { autoClose: 5000 });
            }
        } catch (error) {
            console.error('Delete student error:', error);
            toast.error("Error deleting student", { autoClose: 5000 });
        } finally {
            setDeleting(false);
            closeDeleteModal();
        }
    };
    const confirmMarkAllAsPresent = async () => {
        const headers = {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'token': localStorage.getItem('token'),
        };

        const formattedDate = dayjs(selectedDate).format('YYYY-MM-DD');

        setLoading(true);
        try {
            await Promise.all(
                unrecordedList.map(student => {
                    const payload = {
                        class_id: classId,
                        student_uuid: student.student_uuid,
                        start_date: formattedDate,
                        end_date: formattedDate,
                        status: 1,
                        remarks: '',
                        reason_type: "",
                    };
                    return API.post('/attendance/teacher/record', payload, { headers });
                })
            );

            toast.success("All unrecorded students marked as present.", { autoClose: 5000 });
            fetchStudentsAttendanceDetail(selectedDate);
            fetchStudentsAttendanceSummary(selectedDate);
            setConfirmPresentModalOpen(false);
        } catch (error) {
            console.error("Error bulk updating:", error);
            toast.error("Failed to update some students", { autoClose: 5000 });
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        const loadRotation = async () => {
            const token = localStorage.getItem("token");
            const res = await API.get("/timetable/rotation/info", {
                headers: { token, is_portal: true }
            });

            if (res.data.response_code === 1000) {
                setRotationCycle(res.data.rotation_cycle || 1);
            }
        };

        loadRotation();
    }, []);
    useEffect(() => {
        const monthStr = dayjs(activeMonthDate).format("YYYY-MM");
        console.log("Fetching summary for month:", monthStr);
        fetchStudentsAttendanceSummary(activeMonthDate); // use visible month
    }, [classId, activeMonthDate]); // ✅ use activeMonthDate instead


    useEffect(() => {
        fetchStudentsAttendanceDetail(selectedDate);
    }, [classId, selectedDate]);

    useEffect(() => {
        if (activeSubTab === "timetable") {
            fetchTeachers();
            fetchTimetable();
        }
    }, [activeSubTab]);

    const tileContent = ({ date, view }) => {
        if (view !== "month") return null;

        const formattedDate = dayjs(date).format("YYYY-MM-DD");


        const isHoliday = summary?.holidays?.some(h => h.date === formattedDate);
        if (isHoliday) {
            return (
                <div
                    style={{

                    }}
                />
            );
        }

        // 2️Attendance check
        const record = summary?.date_summary?.find(item => item.date === formattedDate);
        if (!record || record.total_students === 0) return null;

        const ratio = record.total_present / record.total_students;
        const percentage = Math.round(ratio * 100);


        let background = "#f5f6fa";
        let color = "#555";

        if (ratio >= 0.8) { background = "#E8F5E9"; color = "#2E7D32"; }   // good (green)
        else if (ratio >= 0.5) { background = "#FFF8E1"; color = "#8A6D3B"; } // fair (yellow)
        else { background = "#FFEBEE"; color = "#C62828"; }                   // low (red)
        const isMobile = window.innerWidth < 600;

        return (
            <div
                style={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                    width: "100%",
                    background,
                    color,
                    borderRadius: "8px",
                    padding: window.innerWidth < 600 ? "4px" : "6px",
                    fontWeight: 600,
                    fontSize: window.innerWidth < 600 ? "0.75rem" : "0.85rem",
                    textAlign: "center",
                    lineHeight: 1.2,
                    boxSizing: "border-box",
                }}
            >
                {isMobile ? (
                    // 📱 Show only percentage
                    <span>{percentage}%</span>
                ) : (
                    // 💻 Show both ratio and %
                    <>
                        <span>{record.total_present}/{record.total_students}</span>
                        <span style={{ fontSize: "0.7rem", opacity: 0.8 }}>{percentage}%</span>
                    </>
                )}
            </div>
        );


    };

    // Group and filter detailed records by student_uuid and selected date
    const formattedSelectedDate = dayjs(selectedDate).format('YYYY-MM-DD');
    const groupedRecords = students.detailed_records?.reduce((acc, record) => {
        const studentId = record.student_uuid;

        // Initialize the student record if not already present
        if (!acc[studentId]) {
            acc[studentId] = {
                profile_pic: record.profile_pic,
                student_status: record.student_status,
                student_uuid: record.student_uuid,
                first_name: record.first_name,
                moeis_name: record.moeis_name,
                is_twin: record.is_twin || 0,
                attendance: [], // Store attendance details
            };
        }

        // Only include records matching the selected date
        if (record.date === formattedSelectedDate) {
            acc[studentId].attendance.push({
                profile_pic: record.profile_pic,
                student_status: record.student_status,
                date: record.date,
                status: record.status,
                check_in_time: record.check_in_time,
                check_in_gate: record.check_in_gate,
                check_out_time: record.check_out_time,
                check_out_gate: record.check_out_gate,
                check_in_image_url: record.check_in_image_url || null,
                check_out_image_url: record.check_out_image_url || null,
                letter_attachment_url: record.letter_attachment_url || null,
                remarks: record.remarks,
                latitude: record.latitude || null,
                longitude: record.longitude || null,
                is_twin: record.is_twin || 0
            });
        }

        return acc;
    }, {});

    const notifyParent = async (studentUuid) => {
        const headers = {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'token': localStorage.getItem('token'),
        };
        try {
            const response = await API.post(
                `/attendance/notifyParent`,
                JSON.stringify({ student_id: studentUuid }), // Pass the student UUID and date
                { headers }
            );

            if (response.data.response_code === 1000) {
                toast.success("Parent notified successfully", { autoClose: 5000 });
            } else {
                toast.error(response.data.message, { autoClose: 5000 });
            }
        } catch (error) {

            toast.error("Error notifying parent", { autoClose: 5000 });
        }
    };
    const openUpdateClassModal = (student) => {
        setSelectedStudent(student);
        setModalOpen(true);
    };
    const closeModal = () => {
        setSelectedStudent(null);
        setNewClassId('');
        setModalOpen(false);
    };
    // 2. getMCReasons function INSIDE your component
    const getMCReasons = async () => {
        const url = "https://api.schoolpay.tech/attendance/absenceReason";
        try {
            const response = await fetch(url, {
                method: "GET",
                headers: { "Content-Type": "application/json" },
            });
            const responseJSON = await response.json();

            if (responseJSON.response_code === 1000) {
                const reasons = responseJSON.data.map((reason) => ({
                    label: reason.name + (reason.sub_reason ? " - " + reason.sub_reason : ""),
                    value: reason.reason_id,
                }));
                setMCReasons(reasons);
            } else {
                console.error("Failed to fetch MC reasons:", responseJSON.message);
            }
        } catch (error) {
            console.error("Error fetching MC reasons:", error);
        }
    };
    const updateStudentClass = async () => {
        if (!selectedStudent || !newClassId) {
            toast.error("Please select a new class.", { autoClose: 5000 });
            return;
        }

        const headers = {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'token': localStorage.getItem('token'),
        };

        try {
            const response = await API.post(
                `/portal/modifyClass`,
                { student_id: selectedStudent.student_uuid, new_class_id: newClassId },
                { headers }
            );

            if (response.data.response_code === 1000) {
                toast.success("Student class updated successfully!", { autoClose: 5000 });
                fetchStudentsAttendanceDetail(selectedDate);
                fetchStudentsAttendanceSummary(selectedDate);
                closeModal();
            } else {
                toast.error(response.data.message, { autoClose: 5000 });
            }
        } catch (error) {
            console.error('Error updating student class:', error);
            toast.error("Error updating student class", { autoClose: 5000 });
        }
    };
    const submitManualAttendance = async () => {
        const headers = {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'token': localStorage.getItem('token'),
        };

        let payload = {
            class_id: classId,
            student_uuid: selectedStudent.student_uuid,
            start_date: recordStartDate,
            end_date: recordEndDate || recordStartDate,
            status: Number(recordStatus),
        };

        if (Number(recordStatus) === 0) {
            // MC required for Absent
            if (!selectedMCReason) {
                toast.error("Please select a MC/Absence reason.", { autoClose: 5000 });
                return;
            }
            payload.remarks = selectedMCReason.label;
            payload.reason_type = selectedMCReason.value;
        } else {
            // Remarks for present, but NOT MC reason!
            payload.remarks = recordRemarks;
            payload.reason_type = "";
        }

        setLoading(true);

        try {
            const response = await API.post('/attendance/teacher/record', payload, { headers });
            if (response.data.response_code === 1000) {
                toast.success(response.data.message, { autoClose: 5000 });
                setRecordModalOpen(false);
                fetchStudentsAttendanceDetail(selectedDate);
                fetchStudentsAttendanceSummary(selectedDate);
            } else {
                toast.error(response.data.message, { autoClose: 5000 });
            }
        } catch (error) {

            toast.error(error.message, { autoClose: 5000 });

        } finally {
            setLoading(false);
        }
    };
    const openConfirmPresentModal = () => {
        const unrecordedStudents = Object.values(groupedRecords).filter(student =>
            student.attendance.some(att => att.status === '0' || att.status === 'unrecorded')
        );

        if (unrecordedStudents.length === 0) {
            toast.info("No unrecorded students to update.", { autoClose: 5000 });
            return;
        }

        setUnrecordedList(unrecordedStudents);
        setConfirmPresentModalOpen(true);
    };

    const removeFromUnrecordedList = (studentId) => {
        setUnrecordedList(prev => prev.filter(s => s.student_uuid !== studentId));
    };
    const openConfirmAbsentModal = () => {
        const unrecordedStudents = Object.values(groupedRecords).filter(student =>
            student.attendance.some(att => att.status === '0' || att.status === 'unrecorded')
        );

        if (unrecordedStudents.length === 0) {
            toast.info("No unrecorded students to mark as absent.", { autoClose: 5000 });
            return;
        }

        setUnrecordedList(unrecordedStudents);
        setConfirmAbsentModalOpen(true);
    };
    const confirmMarkAllAsAbsent = async () => {
        if (!startBulkDate || !endBulkDate) {
            return alert("Please select start and end dates.");
        }

        if (!selectedBulkMCReason) {
            toast.error("Please select an absence reason first.", { autoClose: 4000 });
            return;
        }

        const headers = {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'token': localStorage.getItem('token'),
        };

        const start = dayjs(startBulkDate);
        const end = dayjs(endBulkDate);
        const daysDiff = end.diff(start, 'day');

        if (daysDiff < 0) {
            return toast.error("Start date cannot be after end date.", { autoClose: 4000 });
        }

        setLoading(true);

        try {
            const requests = [];

            for (let i = 0; i <= daysDiff; i++) {
                const date = start.add(i, 'day').format("YYYY-MM-DD");

                unrecordedList.forEach(student => {
                    const payload = {
                        class_id: classId,
                        student_uuid: student.student_uuid,
                        start_date: date,
                        end_date: date,
                        status: 0,
                        remarks: selectedBulkMCReason.label,
                        reason_type: selectedBulkMCReason.value,
                    };

                    requests.push(API.post("/attendance/teacher/record", payload, { headers }));
                });
            }

            await Promise.all(requests);

            toast.success("All unrecorded students marked as absent for selected dates.", { autoClose: 4000 });

            // Refresh UI
            fetchStudentsAttendanceDetail(selectedDate);
            fetchStudentsAttendanceSummary(selectedDate);
            setConfirmAbsentModalOpen(false);
            setSelectedBulkMCReason(null);
            setStartBulkDate("");
            setEndBulkDate("");
        } catch (error) {
            console.error("Error marking absent:", error);
            toast.error("Failed to mark absences.", { autoClose: 4000 });
        } finally {
            setLoading(false);
        }
    };
    const [subjects, setSubjects] = useState([]);

    const fetchSubjects = async () => {
        try {
            const token = localStorage.getItem("token");
            const res = await API.get("/timetable/subjects", {
                headers: { token, is_portal: true }
            });
            if (res.data.response_code === 1000) {
                setSubjects(
                    res.data.data.map(s => ({
                        label: s.subject_name,
                        value: s.subject_name
                    }))
                );
            }
        } catch (err) {
            console.error("Subjects error:", err);
        }
    };

    // run on mount
    useEffect(() => {
        fetchSubjects();
    }, []);

    const getStatusChip = (status) => {
        switch (status) {
            case '0':
                return (
                    <span
                        style={{
                            backgroundColor: '#f8d7da',
                            color: '#721c24',
                            padding: '5px 10px',
                            borderRadius: '12px',
                            fontWeight: 'bold',
                        }}
                    >
                        Unrecorded
                    </span>
                );
            case '1':
                return (
                    <span
                        style={{
                            backgroundColor: '#f8d7da',
                            color: '#721c24',
                            padding: '5px 10px',
                            borderRadius: '12px',
                            fontWeight: 'bold',
                        }}
                    >
                        Recording in progress
                    </span>
                );
            case '3':
                return (
                    <span
                        style={{
                            backgroundColor: '#ffdddd',
                            color: '#b20000',
                            padding: '4px 8px',
                            borderRadius: '16px',
                            fontWeight: 'bold',
                            border: '2px solid #ff0000',
                            fontSize: '1rem',
                            letterSpacing: '0.02em',
                            boxShadow: '0 0 6px #ff000080',
                            display: 'inline-flex',
                            alignItems: 'center',
                            animation: 'alarmPulse 1s infinite alternate'
                        }}
                    >
                        <span style={{ marginRight: 8, fontSize: '1.3em' }}>⚠️</span>
                        Requires Re-record
                        <style>
                            {`
                        @keyframes alarmPulse {
                            from { box-shadow: 0 0 10px #ff000080; }
                            to   { box-shadow: 0 0 30px #ff0000, 0 0 10px #ff000080; }
                        }
                        `}
                        </style>
                    </span>

                );
            case '4':
                return (
                    <span
                        style={{
                            backgroundColor: '#fff3cd',
                            color: '#155724',
                            padding: '5px 10px',
                            borderRadius: '12px',
                            fontWeight: 'bold',
                        }}
                    >
                        Parents not linked
                    </span>
                );
            case '2':
                return (
                    <span
                        style={{
                            backgroundColor: '#d4edda',
                            color: '#155724',
                            padding: '5px 10px',
                            borderRadius: '12px',
                            fontWeight: 'bold',
                        }}
                    >
                        Parents Linked
                    </span>
                );
            default:
                return (
                    <span
                        style={{
                            backgroundColor: '#f8f9fa',
                            color: '#6c757d',
                            padding: '5px 10px',
                            borderRadius: '12px',
                            fontWeight: 'bold',
                        }}
                    >
                        Unknown
                    </span>
                );
        }
    };
    return (
        <Fragment>
            <div className="container-fluid">
                <div className="row">
                    <div className='row gx-0'>
                        <div className="col-12">
                            <div className="card">
                                <div className="card-header d-flex flex-column flex-lg-row justify-content-between align-items-start align-items-lg-center gap-2">
                                    <h4 className="mb-0 flex-grow-1">Class {className}</h4>

                                    <div className="d-flex gap-2">
                                        <button
                                            className="btn btn-primary d-flex align-items-center gap-2 px-3 py-2 fw-semibold shadow-sm"
                                            onClick={() => setRegisterModalOpen(true)}
                                        >
                                            + Register Student
                                        </button>

                                        <button
                                            className="btn btn-success d-flex align-items-center gap-2 px-3 py-2 fw-semibold shadow-sm"
                                            onClick={openConfirmPresentModal}
                                            disabled={loading}
                                        >
                                            {loading ? (
                                                <>
                                                    <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                                    Processing...
                                                </>
                                            ) : (
                                                <>
                                                    <i className="bi bi-check2-circle"></i>
                                                    Mark All Unrecorded as Present
                                                </>
                                            )}
                                        </button>
                                        <button
                                            className="btn btn-danger d-flex align-items-center gap-2 px-3 py-2 fw-semibold shadow-sm"
                                            onClick={openConfirmAbsentModal}
                                            disabled={loading}
                                        >
                                            {loading ? (
                                                <>
                                                    <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                                    Processing...
                                                </>
                                            ) : (
                                                <>
                                                    <i className="bi bi-x-circle"></i>
                                                    Mark All as Absent
                                                </>
                                            )}
                                        </button>

                                    </div>
                                </div>

                                <div className="card-body">
                                    <div className="calendar-modern">
                                        <Calendar
                                            value={selectedDate}
                       
                                            onChange={(date) => {
                                                setSelectedDate(date);

                                                setStartBulkDate(dayjs(date).format('YYYY-MM-DD'));
                                                setEndBulkDate(dayjs(date).format('YYYY-MM-DD'));
                                                fetchStudentsAttendanceDetail(date);
                                                fetchStudentsAttendanceSummary(date);
                                            }}
                                            onActiveStartDateChange={({ activeStartDate }) => {
                                                setActiveMonthDate(activeStartDate); // ✅ now tracks viewed month
                                            }}
                                            tileContent={tileContent}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <Nav tabs className="mt-3">
                        <NavItem>
                            <NavLink
                                className={classnames({ active: activeSubTab === "students" })}
                                onClick={() => toggleSubTab("students")}
                                style={{ cursor: "pointer" }}
                            >
                                Student List
                            </NavLink>
                        </NavItem>
                        <NavItem>
                            <NavLink
                                className={classnames({ active: activeSubTab === "timetable" })}
                                onClick={() => toggleSubTab("timetable")}
                                style={{ cursor: "pointer" }}
                            >
                                Timetable
                            </NavLink>
                        </NavItem>
                    </Nav>
                    <TabContent activeTab={activeSubTab} className="border-start border-end border-bottom p-3">
                        <TabPane tabId="students">
                            <div className="card-body">

                                {loading ? (
                                    <div className="text-center py-5">
                                        <div className="spinner-border text-danger mb-3" role="status" style={{ width: "3rem", height: "3rem" }} />
                                        <h6 className="fw-semibold text-muted">Loading...</h6>
                                        <small className="text-gray">Please wait while data is being fetched.</small>
                                    </div>

                                ) : groupedRecords && Object.keys(groupedRecords).length > 0 ? (
                                    <>
                                        <div style={{
                                            width: "100%",
                                            overflowX: "auto",
                                            WebkitOverflowScrolling: "touch",
                                            marginTop: "1rem",
                                        }}>
                                            <Table bordered responsive hover style={{ width: '100%', tableLayout: "auto" }}>
                                                <thead>
                                                    <tr>
                                                        <th></th>
                                                        <th>Profile</th>
                                                        <th style={{ width: "120px", minWidth: "80px", textAlign: "center" }}></th>
                                                        <th style={{ width: "120px", minWidth: "80px", textAlign: "center" }}>Status</th>

                                                        <th>Timeline</th>
                                                        <th>Notify Parent</th>
                                                        <th>Action</th>
                                                    </tr>
                                                </thead>

                                                <tbody>
                                                    {Object.values(groupedRecords).map((student, index) => (
                                                        <tr key={student.student_uuid}>
                                                            <td>{index + 1}</td>
                                                            <td>
                                                                <div className="d-flex align-items-center gap-3">
                                                                    <div className="d-flex flex-column">
                                                                        {student.profile_pic ? (
                                                                            <img
                                                                                src={student.profile_pic}
                                                                                alt={`${student.first_name}'s Profile`}
                                                                                style={{
                                                                                    width: '48px',
                                                                                    height: '48px',
                                                                                    borderRadius: '50%',
                                                                                    objectFit: 'cover',
                                                                                    boxShadow: '0 0 4px rgba(0,0,0,0.1)',
                                                                                }}
                                                                            />
                                                                        ) : (
                                                                            <div
                                                                                style={{
                                                                                    width: '48px',
                                                                                    height: '48px',
                                                                                    borderRadius: '50%',
                                                                                    background: '#e9ecef',
                                                                                    display: 'flex',
                                                                                    alignItems: 'center',
                                                                                    justifyContent: 'center',
                                                                                    fontWeight: 'bold',
                                                                                    color: '#6c757d',
                                                                                }}
                                                                            >
                                                                                {student.first_name?.[0]?.toUpperCase() || '?'}
                                                                            </div>
                                                                        )}
                                                                        <div>
                                                                            {Number(student.is_twin) === 1 && (
                                                                                <span
                                                                                    className="badge bg-warning text-dark align-middle"
                                                                                    style={{
                                                                                        fontSize: '0.65rem',
                                                                                        fontWeight: 600,
                                                                                        borderRadius: '10px',
                                                                                        padding: '1px 5px',
                                                                                        lineHeight: 1,
                                                                                        display: 'inline-block',
                                                                                        verticalAlign: 'middle',
                                                                                    }}
                                                                                >
                                                                                    Twin
                                                                                </span>
                                                                            )}
                                                                        </div>
                                                                    </div>

                                                                    <div className="d-flex flex-column">
                                                                        <div>
                                                                            <span className="fw-semibold text-dark me-1">{student.first_name}</span>
                                                                            {student.first_name !== student.moeis_name && (
                                                                                <small className="text-muted">MOEIS: {student.moeis_name}</small>
                                                                            )}
                                                                        </div>

                                                                        <div>
                                                                            <button
                                                                                className="btn btn-sm btn-outline-primary mt-1"
                                                                                onClick={() => openNameModal(student)}
                                                                            >
                                                                                Update Name
                                                                            </button>
                                                                        </div>


                                                                    </div>


                                                                </div>
                                                            </td>


                                                            <td>
                                                                {getStatusChip(student.student_status)} {/* Display the chip */}
                                                            </td>
                                                            <td>
                                                                {/* Render statuses for the student */}
                                                                {student.attendance.map((att, i) => (
                                                                    <div
                                                                        key={i}
                                                                        className="mb-2"
                                                                        style={{
                                                                            display: 'inline-block',
                                                                            padding: '5px 10px',
                                                                            borderRadius: '12px',
                                                                            fontWeight: 'bold',
                                                                            backgroundColor: att.status == '0'
                                                                                ? '#f8d7da' // Light red for background (Absent)
                                                                                : att.status == '1'
                                                                                    ? '#d4edda' // Light green for background (Check-in)
                                                                                    : att.status == '2'
                                                                                        ? '#d1ecf1' // Light blue for background (Check-out)
                                                                                        : '#f8f9fa', // Light gray for background (Unrecorded)
                                                                            color: att.status == '0'
                                                                                ? '#721c24' // Dark red for text (Absent)
                                                                                : att.status == '1'
                                                                                    ? '#155724' // Dark green for text (Check-in)
                                                                                    : att.status == '2'
                                                                                        ? '#0c5460' // Dark blue for text (Check-out)
                                                                                        : '#6c757d', // Dark gray for text (Unrecorded)
                                                                        }}
                                                                    >
                                                                        {att.status == '0'
                                                                            ? 'Absent'
                                                                            : att.status == '1'
                                                                                ? 'Check-in'
                                                                                : att.status == '2'
                                                                                    ? 'Check-out'
                                                                                    : 'Unrecorded'}
                                                                    </div>

                                                                ))}
                                                            </td>
                                                            <td>
                                                                <div className="timeline" style={{ position: 'relative', paddingLeft: '20px', borderLeft: '2px solid #28A745' }}>
                                                                    {student.attendance
                                                                        .filter(att => att.status !== 'unrecorded') // Filter out unrecorded statuses
                                                                        .map((att, i) => {
                                                                            // Calculate duration
                                                                            const duration =
                                                                                att.check_in_time && att.check_out_time
                                                                                    ? moment
                                                                                        .duration(moment.unix(att.check_out_time).diff(moment.unix(att.check_in_time)))
                                                                                        .humanize()
                                                                                    : null;

                                                                            return (
                                                                                <div
                                                                                    key={i}
                                                                                    style={{
                                                                                        position: 'relative',
                                                                                        marginBottom: '20px',
                                                                                        paddingLeft: '20px',
                                                                                    }}
                                                                                >
                                                                                    {/* Timeline Marker */}
                                                                                    <div
                                                                                        style={{
                                                                                            position: 'absolute',
                                                                                            left: '-28px',
                                                                                            top: '0',
                                                                                            width: '15px',
                                                                                            height: '15px',
                                                                                            backgroundColor: '#28A745', // Red color
                                                                                            borderRadius: '50%',
                                                                                            border: '2px solid white',
                                                                                            boxShadow: '0 0 0 2px #28A745',
                                                                                        }}
                                                                                    ></div>

                                                                                    {/* Check-in Time */}
                                                                                    {att.check_in_time && (
                                                                                        <div style={{ color: '#28A745', fontWeight: 'bold', marginBottom: '5px' }}>
                                                                                            Check-in: {moment.unix(att.check_in_time).format('hh:mm A')}
                                                                                            {att.check_in_image_url && att.check_in_gate ? (
                                                                                                <>
                                                                                                    <br /> Gate: {att.check_in_gate}
                                                                                                </>
                                                                                            ) : <> <br />{att.check_in_gate}</>}
                                                                                        </div>
                                                                                    )}

                                                                                    {/* Check-in Image */}
                                                                                    {(att.status == '1' || att.status == '2') && att.check_in_image_url && (
                                                                                        <img
                                                                                            src={att.check_in_image_url}
                                                                                            alt="Check-In"
                                                                                            style={{
                                                                                                width: '120px',
                                                                                                height: '120px',
                                                                                                marginTop: '5px',
                                                                                                borderRadius: '4px',
                                                                                                border: '1px solid #28A745',
                                                                                            }}
                                                                                        />
                                                                                    )}

                                                                                    {/* Check-out Time */}
                                                                                    {att.check_out_time && (
                                                                                        <div style={{ color: '#28A745', fontWeight: 'bold', marginTop: '10px', marginBottom: '5px' }}>
                                                                                            Check-out: {moment.unix(att.check_out_time).format('hh:mm A')}
                                                                                            <br /> Gate: {att.check_out_gate}
                                                                                        </div>
                                                                                    )}

                                                                                    {/* Check-out Image */}
                                                                                    {att.check_out_image_url && (
                                                                                        <img
                                                                                            src={att.check_out_image_url}
                                                                                            alt="Check-Out"
                                                                                            style={{
                                                                                                width: '120px',
                                                                                                height: '120px',
                                                                                                marginTop: '5px',
                                                                                                borderRadius: '4px',
                                                                                                border: '1px solid #28A745',
                                                                                            }}
                                                                                        />
                                                                                    )}

                                                                                    {/* Duration */}
                                                                                    {duration && (
                                                                                        <div style={{ color: '#28A745', marginTop: '10px', fontWeight: 'bold' }}>
                                                                                            Duration: {duration}
                                                                                        </div>
                                                                                    )}
                                                                                    {/* Remarks */}
                                                                                    {att.remarks && (
                                                                                        <div style={{ color: '#28A745', marginTop: '10px' }}>
                                                                                            <strong>Remarks:</strong> {att.remarks}
                                                                                        </div>
                                                                                    )}
                                                                                    {/* Button for Letter Attachment */}
                                                                                    {att.status === '0' && att.letter_attachment_url && (
                                                                                        <div style={{ marginTop: '10px' }}>
                                                                                            <button
                                                                                                style={{
                                                                                                    backgroundColor: '#e74c3c',
                                                                                                    color: 'white',
                                                                                                    border: 'none',
                                                                                                    borderRadius: '5px',
                                                                                                    padding: '5px 10px',
                                                                                                    cursor: 'pointer',
                                                                                                }}
                                                                                                onClick={() => window.open(att.letter_attachment_url, '_blank')}
                                                                                            >
                                                                                                View Letter
                                                                                            </button>
                                                                                        </div>
                                                                                    )}

                                                                                    {/* 🗺️ Map below check-in image */}
                                                                                    {att.latitude && att.longitude && (
                                                                                        <div
                                                                                            style={{
                                                                                                marginTop: '10px',
                                                                                                width: '100%',
                                                                                                height: '200px',
                                                                                                borderRadius: '8px',
                                                                                                overflow: 'hidden',
                                                                                                boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                                                                                            }}
                                                                                        >
                                                                                            <MapContainer
                                                                                                center={[att.latitude, att.longitude]}
                                                                                                zoom={10}
                                                                                                scrollWheelZoom={true}
                                                                                                style={{ height: "100%", width: "100%" }}
                                                                                            >
                                                                                                <TileLayer
                                                                                                    url="https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png"
                                                                                                    subdomains={['a', 'b', 'c', 'd']}
                                                                                                    attribution='&copy; <a href="https://osm.org/copyright">OpenStreetMap</a>'
                                                                                                />
                                                                                                <Marker position={[att.latitude, att.longitude]} icon={glowingIcon}>
                                                                                                    <Popup>
                                                                                                        <b>{student.first_name}</b><br />

                                                                                                    </Popup>
                                                                                                </Marker>
                                                                                                <FitBounds points={[att]} />
                                                                                            </MapContainer>
                                                                                        </div>
                                                                                    )}

                                                                                </div>
                                                                            );
                                                                        })}
                                                                </div>
                                                            </td>
                                                            <td className="align-top">
                                                                <div className="d-flex flex-column gap-3">
                                                                    {student.attendance.some(att => att.status === 'unrecorded') && (
                                                                        <button
                                                                            className="btn btn-sm fw-bold text-uppercase"
                                                                            style={{
                                                                                backgroundColor: '#E94057',
                                                                                color: '#fff',
                                                                                border: '2px solid #E94057',
                                                                                padding: '8px 16px',
                                                                                borderRadius: '12px',
                                                                                boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
                                                                                fontWeight: 'bold',
                                                                                transition: 'all 0.3s ease',
                                                                            }}
                                                                            onClick={() => notifyParent(student.student_uuid)}
                                                                        >
                                                                            Notify Parent
                                                                        </button>
                                                                    )}

                                                                </div>
                                                            </td>
                                                            <td>
                                                                <div className="d-flex flex-column gap-3">
                                                                    <button
                                                                        className="btn btn-sm fw-semibold"
                                                                        style={{
                                                                            backgroundColor: 'white',
                                                                            color: '#E94057',
                                                                            border: '2px solid #E94057',
                                                                            padding: '8px 16px',
                                                                            borderRadius: '12px',
                                                                            boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
                                                                            fontWeight: '600',
                                                                            transition: 'all 0.3s ease',
                                                                        }}
                                                                        onClick={() => openRecordAttendanceModal(student)}
                                                                    >
                                                                        Record Attendance
                                                                    </button>
                                                                    <button
                                                                        className="btn btn-sm fw-semibold"
                                                                        style={{
                                                                            backgroundColor: 'white',
                                                                            color: '#E94057',
                                                                            border: '2px solid #E94057',
                                                                            padding: '8px 16px',
                                                                            borderRadius: '12px',
                                                                            boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
                                                                            fontWeight: '600',
                                                                            transition: 'all 0.3s ease',
                                                                        }}
                                                                        onClick={() => openUpdateClassModal(student)}
                                                                    >
                                                                        Change Class
                                                                    </button>
                                                                    <button
                                                                        className="btn btn-sm fw-semibold"
                                                                        style={{
                                                                            background: 'rgba(233,64,87,0.09)',
                                                                            color: '#E94057',
                                                                            border: '2px solid #E94057',
                                                                            padding: '8px 18px',
                                                                            borderRadius: '24px',
                                                                            fontWeight: 700,
                                                                            letterSpacing: '0.02em',
                                                                            boxShadow: '0 3px 8px rgba(233,64,87,0.13)',
                                                                            display: 'flex',
                                                                            alignItems: 'center',
                                                                            gap: 7,
                                                                            transition: 'all 0.18s',
                                                                            backdropFilter: 'blur(3px)',
                                                                            cursor:
                                                                                student.student_status === '0' ||
                                                                                    student.student_status === '2' ||
                                                                                    student.student_status === '3' ||
                                                                                    student.student_status === '4'
                                                                                    ? 'pointer'
                                                                                    : 'not-allowed',
                                                                            opacity:
                                                                                student.student_status === '0' ||
                                                                                    student.student_status === '2' ||
                                                                                    student.student_status === '3' ||
                                                                                    student.student_status === '4'
                                                                                    ? 1
                                                                                    : 0.45,
                                                                        }}
                                                                        onClick={() => openDeleteModal(student)}
                                                                        disabled={
                                                                            !(
                                                                                student.student_status === '0' ||
                                                                                student.student_status === '2' ||
                                                                                student.student_status === '3' ||
                                                                                student.student_status === '4'
                                                                            )
                                                                        }
                                                                        onMouseOver={e => {
                                                                            if (
                                                                                student.student_status === '0' ||
                                                                                student.student_status === '2' ||
                                                                                student.student_status === '3' ||
                                                                                student.student_status === '4'
                                                                            ) {
                                                                                e.currentTarget.style.background =
                                                                                    'linear-gradient(90deg, #E94057 0%, #F27121 100%)';
                                                                                e.currentTarget.style.color = 'white';
                                                                            }
                                                                        }}
                                                                        onMouseOut={e => {
                                                                            if (
                                                                                student.student_status === '0' ||
                                                                                student.student_status === '2' ||
                                                                                student.student_status === '3' ||
                                                                                student.student_status === '4'
                                                                            ) {
                                                                                e.currentTarget.style.background = 'rgba(233,64,87,0.09)';
                                                                                e.currentTarget.style.color = '#E94057';
                                                                            }
                                                                        }}
                                                                    >
                                                                        <svg
                                                                            width="20"
                                                                            height="20"
                                                                            fill="none"
                                                                            stroke="currentColor"
                                                                            strokeWidth="2"
                                                                            strokeLinecap="round"
                                                                            strokeLinejoin="round"
                                                                            style={{ marginRight: 3 }}
                                                                            viewBox="0 0 24 24"
                                                                        >
                                                                            <polyline points="3 6 5 6 21 6" />
                                                                            <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v2" />
                                                                            <line x1="10" y1="11" x2="10" y2="17" />
                                                                            <line x1="14" y1="11" x2="14" y2="17" />
                                                                        </svg>
                                                                        Delete Student
                                                                    </button>
                                                                </div>
                                                            </td>

                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </Table></div>

                                    </>

                                ) : (
                                    <div className="text-center py-5">
                                        <h6 className="text-muted mb-2">No student check-in for this date</h6>
                                        <small className="text-gray">Try selecting a different date on the calendar.</small>
                                    </div>
                                )}

                            </div>
                        </TabPane>
                        <TabPane tabId="timetable" fade={false}>
                            <TimetableTab
                                selectedDay={selectedDay}
                                setSelectedDay={setSelectedDay}
                                loadingTimetable={loadingTimetable}
                                filteredTimetable={filteredTimetable}
                                openAddModal={() => setAddModalOpen(true)}  // opens the modal
                                teachers={teachers}
                            />
                        </TabPane>

                    </TabContent>

                </div>
                <Modal isOpen={confirmPresentModalOpen} toggle={() => setConfirmPresentModalOpen(false)}>
                    <ModalHeader toggle={() => setConfirmPresentModalOpen(false)}>
                        Confirm Mark All as Present
                    </ModalHeader>
                    <ModalBody>
                        <p>The following students will be marked as <b>Present</b>:</p>
                        <Table bordered hover responsive>
                            <thead className="table-light">
                                <tr>
                                    <th>#</th>
                                    <th>Profile</th>
                                    <th style={{ width: "55%", minWidth: "200px" }}>Name</th>
                                    <th style={{ width: "25%" }}>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {unrecordedList.map((s, idx) => (
                                    <tr key={s.student_uuid}>
                                        <td>{idx + 1}</td>
                                        <td>
                                            {s.profile_pic ? (
                                                <img
                                                    src={s.profile_pic}
                                                    alt={s.first_name}
                                                    style={{
                                                        width: "40px",
                                                        height: "40px",
                                                        borderRadius: "50%",
                                                        objectFit: "cover",
                                                    }}
                                                />
                                            ) : (
                                                <span className="text-muted">N/A</span>
                                            )}
                                        </td>
                                        <td className="fw-semibold">{s.moeis_name}</td>
                                        <td>
                                            <Button
                                                color="danger"
                                                size="sm"
                                                onClick={() => removeFromUnrecordedList(s.student_uuid)}
                                            >
                                                Remove
                                            </Button>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </Table>

                    </ModalBody>
                    <ModalFooter>
                        <Button color="success" onClick={confirmMarkAllAsPresent} disabled={loading}>
                            {loading ? "Processing..." : "Confirm"}
                        </Button>
                        <Button color="secondary" onClick={() => setConfirmPresentModalOpen(false)}>
                            Cancel
                        </Button>
                    </ModalFooter>
                </Modal>

                {/* Modal for Updating Class */}
                <Modal isOpen={modalOpen} toggle={closeModal}>
                    <ModalHeader toggle={closeModal}>Update Student's Class</ModalHeader>
                    <ModalBody>
                        <select
                            className="form-control"
                            value={newClassId}
                            onChange={(e) => setNewClassId(e.target.value)}
                        >
                            <option value="">Select a new class</option>
                            {allClasses.map((cls) => (
                                <option key={cls.class_id} value={cls.class_id}>
                                    {cls.class_name}
                                </option>
                            ))}
                        </select>
                    </ModalBody>
                    <ModalFooter>
                        <Button color="primary" onClick={updateStudentClass}>Update</Button>
                        <Button color="secondary" onClick={closeModal}>Cancel</Button>
                    </ModalFooter>
                </Modal>
                <Modal isOpen={nameModalOpen} toggle={closeNameModal}>
                    <ModalHeader toggle={closeNameModal}>Update Student's Name</ModalHeader>
                    <ModalBody>
                        <input
                            type="text"
                            className="form-control"
                            value={newStudentName}
                            onChange={(e) => setNewStudentName(e.target.value)}
                            placeholder="Enter new student name"
                        />
                    </ModalBody>
                    <ModalFooter>
                        <Button color="primary" onClick={updateStudentName}>Update</Button>
                        <Button color="secondary" onClick={closeNameModal}>Cancel</Button>
                    </ModalFooter>
                </Modal>
                <Modal isOpen={recordModalOpen} toggle={() => setRecordModalOpen(false)}>
                    <ModalHeader toggle={() => setRecordModalOpen(false)}>
                        Manual Attendance Entry
                    </ModalHeader>
                    <ModalBody>
                        {selectedStudent && (
                            <div className="mb-3 p-3 text-black rounded bg-light border">
                                <h5 className="mb-1">{selectedStudent.first_name}</h5>
                                {selectedStudent.moeis_name && selectedStudent.moeis_name !== selectedStudent.first_name && (
                                    <small className="text-muted">MOEIS Name: {selectedStudent.moeis_name}</small>
                                )}
                            </div>
                        )}

                        <div className="form-group">
                            <label>Start Date</label>
                            <input
                                type="date"
                                className="form-control"
                                value={recordStartDate}
                                onChange={(e) => setRecordStartDate(e.target.value)}
                            />
                        </div>

                        <div className="form-group">
                            <label>End Date (optional)</label>
                            <input
                                type="date"
                                className="form-control"
                                value={recordEndDate}
                                onChange={(e) => setRecordEndDate(e.target.value)}
                            />
                        </div>

                        <div className="form-group">
                            <label>Status</label>
                            <select
                                className="form-control"
                                value={recordStatus}
                                onChange={(e) => setRecordStatus(e.target.value)}
                            >
                                <option value={0}>Absent</option>
                                <option value={1}>Present</option>
                            </select>
                        </div>
                        {recordStatus == 0 ? <div className="form-group">
                            <label>MC/Absence Reason</label>
                            <select
                                className="form-control"
                                value={selectedMCReason?.value || ""}
                                onChange={e => {
                                    const selected = mcReasons.find(r => String(r.value) === e.target.value);
                                    setSelectedMCReason(selected || null);
                                }}
                            >
                                <option value="">-- Select Reason --</option>
                                {mcReasons.map(r => (
                                    <option key={r.value} value={r.value}>
                                        {r.label}
                                    </option>
                                ))}
                            </select>

                        </div> : null}
                        {recordStatus != 0 ? <div className="form-group">
                            <label>Remarks</label>
                            <input
                                type="text"
                                className="form-control"
                                value={recordRemarks}
                                onChange={(e) => setRecordRemarks(e.target.value)}
                            />
                        </div> : null}
                    </ModalBody>
                    <ModalFooter>
                        <Button color="primary" onClick={submitManualAttendance}>Submit</Button>
                        <Button color="secondary" onClick={() => setRecordModalOpen(false)}>Cancel</Button>
                    </ModalFooter>
                </Modal>
                <Modal isOpen={deleteModalOpen} toggle={closeDeleteModal}>
                    <ModalHeader toggle={closeDeleteModal}>Confirm Delete</ModalHeader>
                    <ModalBody>
                        {studentToDelete && (
                            <div>
                                Are you sure you want to <b>delete</b> the student "<b>{studentToDelete.first_name}</b>"? <br />
                                This action <b>cannot be undone</b>.
                            </div>
                        )}
                    </ModalBody>
                    <ModalFooter>
                        <Button
                            color="danger"
                            onClick={confirmDeleteStudent}
                            disabled={deleting}
                            style={{
                                minWidth: 120,
                                fontWeight: 700,
                                boxShadow: '0 2px 10px #e9405755',
                                background: 'linear-gradient(90deg, #E94057 0%, #F27121 100%)',
                                border: 'none',
                                borderRadius: '30px',
                                fontSize: '1rem',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                gap: 8,
                                opacity: deleting ? 0.7 : 1,
                                transition: 'all 0.2s'
                            }}
                        >
                            {deleting ? (
                                <>
                                    <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true" />
                                    Deleting...
                                </>
                            ) : (
                                <>Delete</>
                            )}
                        </Button>

                        <Button color="secondary" onClick={closeDeleteModal}>Cancel</Button>
                    </ModalFooter>
                </Modal>
                <Modal isOpen={registerModalOpen} toggle={() => setRegisterModalOpen(false)} size="lg">
                    <ModalHeader toggle={() => setRegisterModalOpen(false)}>
                        Register New Student(s)
                    </ModalHeader>
                    <ModalBody>
                        {/* Tabs */}
                        <ul className="nav nav-tabs mb-3">
                            <li className="nav-item">
                                <button
                                    className={`nav-link ${activeTab === "manual" ? "active" : ""}`}
                                    onClick={() => setActiveTab("manual")}
                                >
                                    Manual
                                </button>
                            </li>
                            <li className="nav-item">
                                <button
                                    className={`nav-link ${activeTab === "csv" ? "active" : ""}`}
                                    onClick={() => setActiveTab("csv")}
                                >
                                    CSV Upload
                                </button>
                            </li>
                            <li className="nav-item">
                                <button
                                    className={`nav-link ${activeTab === "raw" ? "active" : ""}`}
                                    onClick={() => setActiveTab("raw")}
                                >
                                    Raw Input
                                </button>
                            </li>
                        </ul>
                        {/* Raw Input */}
                        {activeTab === "raw" && (
                            <div className="p-3 border rounded">
                                <p className="text-muted">
                                    Paste or type student names below, one per line.
                                    Each line will be treated as a new student.
                                </p>

                                <textarea
                                    className="form-control mb-3"
                                    rows="8"
                                    placeholder="Enter one name per line..."
                                    value={rawInput}
                                    onChange={async (e) => {
                                        setRawInput(e.target.value);
                                        const lines = e.target.value
                                            .split("\n")
                                            .map(line => line.trim())
                                            .filter(line => line.length > 0);
                                        setRawNames(lines);
                                        if (lines.length > 0) {
                                            try {
                                                const headers = {
                                                    'Content-Type': 'application/json',
                                                    'token': localStorage.getItem("token"),
                                                };
                                                const response = await API.post(
                                                    "/student/bulkCheckByMoeisName",
                                                    { names: lines },
                                                    { headers }
                                                );

                                                if (response.data.response_code === 1000) {
                                                    setRawCheckResults(response.data.data);
                                                } else {
                                                    toast.error(response.data.message || "Failed to check existing students");
                                                }
                                            } catch (err) {
                                                console.error("Raw check error:", err);
                                                toast.error("Error checking raw input names");
                                            }
                                        } else {
                                            setRawCheckResults(null);
                                        }
                                    }}
                                />
                                {rawNames.length > 0 && (
                                    <div className="mt-3">
                                        <h6 className="fw-bold">Preview ({rawNames.length} students):</h6>
                                        <ul className="list-group" style={{ maxHeight: "300px", overflowY: "auto" }}>
                                            {rawNames.map((name, idx) => {
                                                const foundStudent = rawCheckResults?.found?.find(
                                                    f => f.moeis_name.trim() === name.trim()
                                                );
                                                const notFound = rawCheckResults?.not_found?.includes(name);

                                                const statusInfo = foundStudent
                                                    ? statusMap[String(foundStudent.status)] || { text: "Unknown", color: "dark" }
                                                    : null;

                                                return (
                                                    <li
                                                        key={idx}
                                                        className="list-group-item d-flex justify-content-between align-items-center"
                                                        style={{
                                                            backgroundColor: foundStudent ? "#fff8e1" : "#e8f5e9", // yellow if found, green if new
                                                            borderLeft: foundStudent ? "4px solid #ffb300" : "4px solid #43a047", // orange if exists, green if new
                                                        }}
                                                    >
                                                        <div className="d-flex flex-column">
                                                            <span className="fw-semibold">{idx + 1}. {name}</span>

                                                            {foundStudent && (
                                                                <small className="text-muted">
                                                                    Exists in <b>{foundStudent.class_name}</b>{" "}
                                                                    <span className={`badge bg-${statusInfo.color} ms-1`}>
                                                                        {statusInfo.text}
                                                                    </span>
                                                                </small>
                                                            )}

                                                            {notFound && (
                                                                <span className="badge bg-success mt-1" style={{ width: "fit-content" }}>
                                                                    New Student
                                                                </span>
                                                            )}
                                                        </div>

                                                        <button
                                                            className="btn btn-sm btn-outline-danger"
                                                            onClick={() => {
                                                                setRawNames(prev => prev.filter((_, i) => i !== idx));
                                                                setRawInput(prev =>
                                                                    prev.split("\n").filter((_, i) => i !== idx).join("\n")
                                                                );
                                                            }}
                                                        >
                                                            Remove
                                                        </button>
                                                    </li>
                                                );
                                            })}
                                        </ul>
                                    </div>
                                )}

                            </div>
                        )}
                        {/* Manual Registration */}
                        {activeTab === "manual" && (
                            <div>
                                <div className="form-group mb-3">
                                    <label>First Name</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        value={newStudent.first_name}
                                        onChange={(e) =>
                                            setNewStudent({ ...newStudent, first_name: e.target.value })
                                        }
                                        placeholder="Enter student first name"
                                    />
                                </div>
                                <div className="form-group mb-3">
                                    <label>MOEIS Name</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        value={newStudent.moeis_name}
                                        onChange={(e) =>
                                            setNewStudent({ ...newStudent, moeis_name: e.target.value })
                                        }
                                        placeholder="Enter MOEIS full name"
                                    />
                                </div>
                                <div className="form-group mb-3">
                                    <label>Class</label>
                                    <select
                                        className="form-control"
                                        value={newStudent.class_id}
                                        onChange={(e) =>
                                            setNewStudent({ ...newStudent, class_id: e.target.value })
                                        }
                                    >
                                        <option value="">-- Select Class --</option>
                                        {allClasses.map((cls) => (
                                            <option key={cls.class_id} value={cls.class_id}>
                                                {cls.class_name}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                            </div>
                        )}

                        {/* CSV Upload */}
                        {activeTab === "csv" && (
                            <div className="p-3 border rounded">
                                <p className="text-muted">
                                    Upload a CSV file with <b>FULL NAME only</b> (one per line).
                                    All students will be registered under the current class.
                                </p>
                                <input
                                    type="file"
                                    accept=".csv"
                                    className="form-control"
                                    onChange={(e) => {
                                        const file = e.target.files[0];
                                        if (!file) return;

                                        if (
                                            file.type !== "text/csv" &&
                                            file.type !== "application/vnd.ms-excel" && // some browsers report CSV as this
                                            !file.name.toLowerCase().endsWith(".csv")
                                        ) {
                                            toast.error("Only CSV files are allowed.", { autoClose: 5000 });
                                            e.target.value = ""; // clear the input
                                            setCsvFile(null);
                                            setParsedCsvNames([]);
                                            return;
                                        }

                                        setCsvFile(file);

                                        Papa.parse(file, {
                                            header: false,
                                            complete: async (results) => {
                                                const names = results.data
                                                    .map(row => row[0]?.trim())
                                                    .filter(name => name);

                                                setParsedCsvNames(names);

                                                if (names.length > 0) {
                                                    try {
                                                        const headers = {
                                                            'Content-Type': 'application/json',
                                                            'token': localStorage.getItem("token"),
                                                        };
                                                        const response = await API.post(
                                                            "/student/bulkCheckByMoeisName",
                                                            { names },
                                                            { headers }
                                                        );

                                                        if (response.data.response_code === 1000) {
                                                            setCsvCheckResults(response.data.data);
                                                        } else {
                                                            toast.error(response.data.message || "Failed to check existing students");
                                                        }
                                                    } catch (err) {
                                                        console.error("Check error:", err);
                                                        toast.error("Error checking CSV names");
                                                    }
                                                }
                                            }
                                        });
                                    }}
                                />

                                {csvFile && (
                                    <div className="mt-3">
                                        <h6 className="fw-bold">Preview ({parsedCsvNames.length} students):</h6>
                                        <ul className="list-group" style={{ maxHeight: "300px", overflowY: "auto" }}>
                                            {parsedCsvNames.map((name, idx) => {
                                                const foundStudent = csvCheckResults?.found?.find(
                                                    f => f.moeis_name.trim() === name.trim()
                                                );
                                                const notFound = csvCheckResults?.not_found?.includes(name);

                                                // Choose status info if found
                                                const statusInfo = foundStudent ? statusMap[String(foundStudent.status)] || { text: "Unknown", color: "dark" } : null;

                                                return (
                                                    <li
                                                        key={idx}
                                                        className="list-group-item d-flex justify-content-between align-items-center"
                                                        style={{
                                                            backgroundColor: foundStudent ? "#fff8e1" : "#e8f5e9", // yellowish if found, greenish if new
                                                            borderLeft: foundStudent ? "4px solid #ffb300" : "4px solid #43a047", // orange for existing, green for new
                                                        }}
                                                    >
                                                        <div className="d-flex flex-column">
                                                            <span className="fw-semibold">{idx + 1}. {name}</span>

                                                            {foundStudent && (
                                                                <small className="text-muted">
                                                                    Exists in <b>{foundStudent.class_name}</b>{" "}
                                                                    <span className={`badge bg-${statusInfo.color} ms-1`}>
                                                                        {statusInfo.text}
                                                                    </span>
                                                                </small>
                                                            )}

                                                            {notFound && (
                                                                <span className="badge bg-success mt-1" style={{ width: "fit-content" }}>
                                                                    New Student
                                                                </span>
                                                            )}
                                                        </div>

                                                        <button
                                                            className="btn btn-sm btn-outline-danger"
                                                            onClick={() => setParsedCsvNames(prev => prev.filter((_, i) => i !== idx))}
                                                        >
                                                            Remove
                                                        </button>
                                                    </li>
                                                );
                                            })}
                                        </ul>
                                    </div>
                                )}

                            </div>
                        )}
                    </ModalBody>

                    <ModalFooter>
                        <Button
                            color="primary"
                            disabled={registering}
                            onClick={async () => {
                                setRegistering(true);
                                try {
                                    const headers = { token: localStorage.getItem("token") };
                                    let payload = [];

                                    if (activeTab === "manual") {
                                        if (!newStudent.first_name || !newStudent.class_id) {
                                            toast.error("Please fill in all required fields.", { autoClose: 5000 });
                                            setRegistering(false);
                                            return;
                                        }
                                        payload = [newStudent]; // wrap in array
                                    } else if (activeTab === "csv") {
                                        if (parsedCsvNames.length === 0) {
                                            toast.error("No valid students found in CSV.", { autoClose: 5000 });
                                            setRegistering(false);
                                            return;
                                        }
                                        payload = parsedCsvNames.map(name => ({
                                            first_name: name,
                                            moeis_name: name,
                                            class_id: classId,
                                        }));
                                    } else if (activeTab === "raw") {
                                        if (rawNames.length === 0) {
                                            toast.error("No valid students entered.", { autoClose: 5000 });
                                            setRegistering(false);
                                            return;
                                        }
                                        payload = rawNames.map(name => ({
                                            first_name: name,
                                            moeis_name: name,
                                            class_id: classId,
                                        }));
                                    }

                                    const response = await API.post(
                                        "/student/registerStudentByAdminPortal",
                                        { students: payload },
                                        { headers }
                                    );

                                    if (response.data.response_code === 1000) {
                                        toast.success("Students registered successfully!", { autoClose: 5000 });
                                        fetchStudentsAttendanceDetail(selectedDate);
                                        fetchStudentsAttendanceSummary(selectedDate);
                                        setRegisterModalOpen(false);
                                        setNewStudent({ first_name: "", moeis_name: "", class_id: classId });
                                        setCsvFile(null);
                                        setParsedCsvNames([]);
                                        setRawInput("");
                                        setRawNames([]);
                                    } else {
                                        toast.error(response.data.message || "Failed to register", { autoClose: 5000 });
                                    }
                                } catch (error) {
                                    toast.error("Error registering student(s)", { autoClose: 5000 });
                                } finally {
                                    setRegistering(false);
                                }
                            }}
                        >
                            {registering ? "Processing..." : "Register"}
                        </Button>

                        <Button color="secondary" onClick={() => setRegisterModalOpen(false)}>
                            Cancel
                        </Button>
                    </ModalFooter>
                </Modal>
                <Modal isOpen={confirmAbsentModalOpen} toggle={() => setConfirmAbsentModalOpen(false)}>
                    <ModalHeader toggle={() => setConfirmAbsentModalOpen(false)}>
                        Confirm Mark All as Absent
                    </ModalHeader>
                    <ModalBody>
                        <div className="form-group mb-3">
                            <label><b>Date Range</b></label>
                            <div className="d-flex gap-2">
                                <input
                                    type="date"
                                    className="form-control"
                                    value={startBulkDate}
                                    onChange={(e) => setStartBulkDate(e.target.value)}
                                />
                                <input
                                    type="date"
                                    className="form-control"
                                    value={endBulkDate}
                                    onChange={(e) => setEndBulkDate(e.target.value)}
                                />
                            </div>
                        </div>

                        <p>
                            Select an <b>absence reason</b> and confirm to mark all unrecorded students as
                            <span className="text-danger fw-bold"> Absent</span>.
                        </p>

                        <div className="form-group mb-3">
                            <label><b>Absence Reason</b></label>
                            <select
                                className="form-control"
                                value={selectedBulkMCReason?.value || ""}
                                onChange={e => {
                                    const selected = mcReasons.find(r => String(r.value) === e.target.value);
                                    setSelectedBulkMCReason(selected || null);
                                }}
                            >
                                <option value="">-- Select Reason --</option>
                                {mcReasons.map(r => (
                                    <option key={r.value} value={r.value}>
                                        {r.label}
                                    </option>
                                ))}
                            </select>
                        </div>
                        <ModalFooter>
                            <Button
                                color="success"
                                onClick={confirmMarkAllAsAbsent}
                                disabled={loading}
                            >
                                {loading ? "Processing..." : "Confirm"}
                            </Button>
                            <Button
                                color="secondary"
                                onClick={() => setConfirmAbsentModalOpen(false)}
                            >
                                Cancel
                            </Button>
                        </ModalFooter>
                        <Table bordered hover responsive>
                            <thead className="table-light">
                                <tr>
                                    <th>#</th>
                                    <th>Profile</th>
                                    <th>Name</th>
                                    <th>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {unrecordedList.map((s, idx) => (
                                    <tr key={s.student_uuid}>
                                        <td>{idx + 1}</td>
                                        <td>
                                            {s.profile_pic ? (
                                                <img
                                                    src={s.profile_pic}
                                                    alt={s.first_name}
                                                    style={{
                                                        width: "40px",
                                                        height: "40px",
                                                        borderRadius: "50%",
                                                        objectFit: "cover",
                                                    }}
                                                />
                                            ) : (
                                                <span className="text-muted">N/A</span>
                                            )}
                                        </td>
                                        <td className="fw-semibold">{s.moeis_name}</td>
                                        <td>
                                            <Button
                                                color="danger"
                                                size="sm"
                                                onClick={() => removeFromUnrecordedList(s.student_uuid)}
                                            >
                                                Remove
                                            </Button>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </Table>
                    </ModalBody>
                </Modal>
                <AddTimetableModal
                    subjects={subjects}
                    isOpen={addModalOpen}
                    onClose={() => setAddModalOpen(false)}
                    classId={classId}
                    teachers={teachers}
                    onAdded={fetchTimetable}
                    selectedDay={selectedDay}
                    existingDayTimetable={filteredTimetable}
                />
            </div>
        </Fragment>
    );
};

export default ClassProfile;
